// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__Cn4RY","footerText":"Footer_footerText__rlW5Y","footerLink":"Footer_footerLink__zoJJ6"};